module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notFound"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6270f171!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotFound.vue
// module id = 94
// module chunks = 2